import ProductPage from "./ProductAdminPage";

export default ProductPage;
